import { HeatmapSettings } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import * as segment from '@fullstory/proto/fs/api/segment';

// Note some lot of these strings are duplicated but we want to make sure the event values doesn't change if we
// update the other items.
export const heatmapTypeToString: { [key in HeatmapSettings.HeatmapType]: string } = {
  // NOTE: **DON'T** i18n these values! They are used for our internal events only
  [HeatmapSettings.HeatmapType.HEATMAP_TYPE_UNSPECIFIED]: 'Unspecified',
  [HeatmapSettings.HeatmapType.HEATMAP_TYPE_CLICK]: 'Click Map',
  [HeatmapSettings.HeatmapType.HEATMAP_TYPE_SCROLL]: 'Scroll Map',
  [HeatmapSettings.HeatmapType.HEATMAP_TYPE_CONVERSION]: 'Conversion',
  [HeatmapSettings.HeatmapType.HEATMAP_TYPE_ENGAGEMENT]: 'Click Area',
};

export const clickTypeToString: { [key in HeatmapSettings.ClickType]: string } = {
  // NOTE: **DON'T** i18n these values! They are used for our internal events only
  [HeatmapSettings.ClickType.CLICK_TYPE_ALL_CLICKS]: 'All',
  [HeatmapSettings.ClickType.CLICK_TYPE_DEAD_CLICKS]: 'Dead',
  [HeatmapSettings.ClickType.CLICK_TYPE_ERROR_CLICKS]: 'Error',
  [HeatmapSettings.ClickType.CLICK_TYPE_RAGE_CLICKS]: 'Rage',
  [HeatmapSettings.ClickType.CLICK_TYPE_INVALID]: 'Invalid',
};

export const deviceTypeToString: { [key in segment.Device]: string } = {
  // NOTE: **DON'T** i18n these values! They are used for our internal events only
  [segment.Device.DEVICE_INVALID]: 'Invalid',
  [segment.Device.DEVICE_UNKNOWN]: 'Unknown',
  [segment.Device.DEVICE_DESKTOP]: 'Desktop',
  [segment.Device.DEVICE_MOBILE]: 'Mobile',
  [segment.Device.DEVICE_TABLET]: 'Tablet',
  [segment.Device.DEVICE_ROBOT]: 'Robot',
};
